module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms2_m.b780ca56c5224f62174d1fbd197d8c47.png";